import { requestDataIntegration } from '@sentry/core';
import { rewriteFramesIntegration, extraErrorDataIntegration, init as init$1 } from '@sentry/nextjs';
export * from '@sentry/nextjs';
import beforeSend from './beforeSend.mjs';

const init = ({
  isProductionBuild,
  isServer,
  dsn,
  release = "development",
  environment = "development",
  denyUrls,
  ignoreErrors
}) => {
  if (!dsn) {
    return;
  }
  const integrations = [];
  if (isServer && dsn) {
    integrations.push(
      rewriteFramesIntegration({
        iteratee: (frame) => {
          frame.filename = frame.filename?.replace(release, "app:///");
          frame.filename = frame.filename?.replace(".next", "_next");
          return frame;
        }
      })
    );
    integrations.push(extraErrorDataIntegration({ depth: 10 }));
    integrations.push(
      requestDataIntegration({
        include: { cookies: false }
      })
    );
  }
  init$1({
    enabled: isProductionBuild,
    integrations,
    dsn,
    release,
    environment,
    beforeSend,
    ignoreErrors,
    denyUrls
  });
};

export { init };
//# sourceMappingURL=index.mjs.map
